import script from "./PosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PosView.vue?vue&type=script&lang=ts&setup=true"

import "./PosView.vue?vue&type=style&index=0&id=4e01c0b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e01c0b6"]])

export default __exports__